// removed by extract-text-webpack-plugin
module.exports = {"parentModal":"Modal__parentModal__EIxYf","closeIcon":"Modal__closeIcon__25cmy","summary":"Modal__summary__2o7gN","table":"Modal__table__17GvT","bigDevices":"Modal__bigDevices__2w2xH"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Modal/Modal.css
// module id = 232
// module chunks = 0